import React from 'react';
import { StepProps } from '../../types/form';
import { FormField } from '../ui/FormField';
import { ToggleGroup } from '../ui/ToggleGroup';
import { PlusIcon, TrashIcon } from 'lucide-react';
export function LegalHelplineStep({
  formData,
  updateFormData,
  errors
}: StepProps) {
  const addEmail = () => {
    updateFormData({
      helplineEmails: [...formData.helplineEmails, {
        name: '',
        description: '',
        email: ''
      }]
    });
  };
  const removeEmail = (index: number) => {
    updateFormData({
      helplineEmails: formData.helplineEmails.filter((_, i) => i !== index)
    });
  };
  const updateEmail = (index: number, field: 'name' | 'description' | 'email', value: string) => {
    updateFormData({
      helplineEmails: formData.helplineEmails.map((entry, i) => i === index ? {
        ...entry,
        [field]: value
      } : entry)
    });
  };
  return <div className="space-y-6" data-id="element-125">
      <div data-id="element-126">
        <h2 className="text-lg font-semibold text-foreground" data-id="element-127">24/7 Legal Helpline</h2>
        <p className="text-sm text-muted-foreground" data-id="element-128">
          Configure the phone line and email contacts for this group.
        </p>
      </div>

      <FormField id="hasHelpline" label="24/7 Legal Helpline" required error={errors.hasHelpline} data-id="element-129">
        <ToggleGroup value={formData.hasHelpline} onChange={val => updateFormData({
        hasHelpline: val,
        ...(val === false ? {
          hasAccessToIntakeForm: null
        } : {})
      })} options={[{
        label: 'On',
        value: true
      }, {
        label: 'Off',
        value: false
      }]} error={!!errors.hasHelpline} data-id="element-130" />
      </FormField>

      {formData.hasHelpline && <div className="space-y-4" data-id="element-131">
          <FormField id="hasAccessToIntakeForm" label="Access to Intake Form" required hint="When on, users can submit legal questions via the web intake form on 24/7 Legal Help. When off, phone-only access is shown." error={errors.hasAccessToIntakeForm} data-id="element-132">
            <ToggleGroup value={formData.hasAccessToIntakeForm} onChange={val => updateFormData({
          hasAccessToIntakeForm: val
        })} options={[{
          label: 'On',
          value: true
        }, {
          label: 'Off',
          value: false
        }]} error={!!errors.hasAccessToIntakeForm} data-id="element-133" />
          </FormField>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-134">
            <FormField id="helplineMaskNumber" label="Display Number" required hint="What users see, e.g. 1-833-URLAWVO" error={errors.helplineMaskNumber} data-id="element-135">
              <input id="helplineMaskNumber" type="text" value={formData.helplineMaskNumber} onChange={e => updateFormData({
            helplineMaskNumber: e.target.value
          })} className={`w-full px-3 py-2 bg-background border rounded-md text-sm ${errors.helplineMaskNumber ? 'border-destructive' : 'border-input'}`} placeholder="e.g. 1-833-URLAWVO" data-id="element-136" />
            </FormField>
            <FormField id="helplineRealNumber" label="Actual Phone Number" required hint="The real number behind the display number" error={errors.helplineRealNumber} data-id="element-137">
              <input id="helplineRealNumber" type="text" value={formData.helplineRealNumber} onChange={e => updateFormData({
            helplineRealNumber: e.target.value
          })} className={`w-full px-3 py-2 bg-background border rounded-md text-sm ${errors.helplineRealNumber ? 'border-destructive' : 'border-input'}`} placeholder="e.g. +1-833-875-2986" data-id="element-138" />
            </FormField>
          </div>

          <FormField id="helplinePrimaryEmail" label="Primary 24/7 Email" hint="Main email shown for the legal line" data-id="element-139">
            <input type="email" value={formData.helplinePrimaryEmail} onChange={e => updateFormData({
          helplinePrimaryEmail: e.target.value
        })} className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm" placeholder="e.g. support@client.com" data-id="element-140" />
          </FormField>

          <div className="space-y-4" data-id="element-141">
            <div className="flex items-center justify-between border-b border-border pb-2" data-id="element-142">
              <h3 className="text-sm font-semibold text-foreground" data-id="element-143">Additional Email Contacts</h3>
              <button type="button" onClick={addEmail} className="flex items-center gap-1.5 text-sm font-medium text-violet-blue" data-id="element-144">
                <PlusIcon className="w-4 h-4" data-id="element-145" />
                Add Email
              </button>
            </div>
            {formData.helplineEmails.map((entry, index) => <div key={index} className="bg-muted/30 border border-border rounded-md p-4 space-y-3" data-id="element-146">
                <div className="flex justify-between items-center" data-id="element-147">
                  <span className="text-xs font-medium text-muted-foreground uppercase" data-id="element-148">
                    Contact {index + 1}
                  </span>
                  <button type="button" onClick={() => removeEmail(index)} data-id="element-149">
                    <TrashIcon className="w-4 h-4 text-muted-foreground hover:text-destructive" data-id="element-150" />
                  </button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-151">
                  <input type="text" value={entry.name} onChange={e => updateEmail(index, 'name', e.target.value)} placeholder="Name" className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm" data-id="element-152" />
                  <input type="email" value={entry.email} onChange={e => updateEmail(index, 'email', e.target.value)} placeholder="Email" className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm" data-id="element-153" />
                </div>
                <input type="text" value={entry.description} onChange={e => updateEmail(index, 'description', e.target.value)} placeholder="Description (optional)" className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm" data-id="element-154" />
              </div>)}
          </div>
        </div>}
    </div>;
}